import { Box, Container, Grid } from '@mui/material'
import { SectionHeading } from '@/components/common'
import { pricingTiers } from '@/data/pricing'
import { PricingCard } from './PricingCard'
import { SECTION_IDS } from '@/utils/constants'

/**
 * Pricing Section Component
 * Displays pricing tiers with 3 pricing cards
 */
export const PricingSection = () => {
  return (
    <Box
      component="section"
      id={SECTION_IDS.PRICING}
      sx={{
        py: { xs: 8, md: 10 },
        bgcolor: 'background.default',
      }}
    >
      <Container maxWidth="lg">
        <SectionHeading align="center" underline>
          Simple, Transparent Pricing
        </SectionHeading>

        <Grid container spacing={{ xs: 3, md: 4 }} sx={{ alignItems: 'stretch' }}>
          {pricingTiers.map((tier) => (
            <Grid item xs={12} md={4} key={tier.id}>
              <PricingCard tier={tier} />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}
